
export const checkVersion=(data)=>{
    return{
        type: 'CHECK_VERSION',
        data
    }
}
